import React from 'react'
import ReactEcharts from 'echarts-for-react';
import * as echarts from "echarts";

export default function SingleLineChart({grid, legend, data}) {
 const option = {
    legend: legend,
    tooltip: {
      show: true,
      formatter: (params) => {
        return `${params?.marker} <b>${params?.name}</b>: ${params?.value?.toFixed(1)}% (${params?.data?.NUMERIC_VALUE?.toFixed(0)})`
      },
    },
    grid: grid,
    xAxis: {
      type: "category",
      boundaryGap: false,
      splitLine: {
        show: false,
        lineStyle: { color: "rgba(255,255,255,0.14)" },
      },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        color: "#D6D6D6",
        fontSize: 10,
        overflow: "break",
        interval: 0,
      },
      // data: ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"],
      data: data?.map(item => item?.MONTH),
    },
    yAxis: {
      type: "value",
      name: "Attendance Rate(%)",
      nameLocation: "middle", 
      nameRotate: 90,         
      nameGap: 45,
      nameTextStyle: {
        fontSize: 10,
        color: '#828A91',
      },
      splitLine: { show: false },
      axisLabel: {
        show: true,
        color: "#D6D6D6",
        fontSize: 12,
        padding: [0, 15, 0, 0],
      },
      min: function (value) {
        return (Math.floor(value?.min / 10) * 10);
      },
      // max: 98,
      // interval: 2,
    },
    series: [
      {
        name: "Days",
        type: "line",
        symbolSize: 10,
        symbol: "circle",
        itemStyle: { color: "#D46C58" , borderWidth: 2, },
        lineStyle: { color: "#D46C58", width: 2 },
        // areaStyle: {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: "rgb(161, 37, 42,0.60)" },
        //     { offset: 1, color: "rgba(229, 241, 232, 0.50)" },
        //   ]),
        // },
        // data: [95, 94, 93, 93, 92, 94, 96],
        data: data?.map(item => ({
          value: item?.ATTENDANCE_RATE,
          ...item
        })),
        label: {
          show: false,
          position: "top",
          color: "#19212A",
          fontSize: 8,
        //   distance: 3,
        },
      },
    ],
  };


  return (
     <ReactEcharts
        option={option}
        opts={{renderer:'svg'}}
        style={{ width: '100%', height: '100%' }}
    />
  )
}